import { Sheet, SheetContent } from '@repo/shadcn';
import { FC } from 'react';

import { useRolePermission } from '../../templates/users/role.permission.list/role-permission.hook';

interface SheetWrapperProps {
    children: React.ReactNode;
    className?: string;
    position: 'top' | 'left' | 'right' | 'bottom';
}

const SheetWrapper: FC<SheetWrapperProps> = ({
    children,
    position,
    className,
}) => {
    const { open, onOpenChange } = useRolePermission();
    return (
        <Sheet key={position} open={open} onOpenChange={onOpenChange}>
            <SheetContent className={`!p-10 ${className}`} side={position}>
                {children}
            </SheetContent>
        </Sheet>
    );
};

export default SheetWrapper;
